import { Link } from "react-router-dom";

const shortcuts = [
  {
    type: "新闻主播",
    desc: "权威资讯 · 深度访谈 · 现场直播",
    icon: "ri-newspaper-line",
    count: "4 位主播",
  },
  {
    type: "娱乐主播",
    desc: "明星星闻 · 红毯直击 · 音乐舞台",
    icon: "ri-star-smile-line",
    count: "4 位主播",
  },
  {
    type: "综艺主播",
    desc: "爆笑现场 · 脱口秀 · 综艺大赏",
    icon: "ri-emotion-happy-line",
    count: "4 位主播",
  },
];

export default function CategoryShortcuts() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {shortcuts.map((item) => (
        <Link
          key={item.type}
          to={`/category?type=${encodeURIComponent(item.type)}`}
          className="group relative flex items-center gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-accent-300 transition-colors overflow-hidden"
        >
          <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-lg bg-primary-600 text-background-50 group-hover:bg-accent-500 transition-colors">
            <i className={`${item.icon} text-2xl`}></i>
          </span>
          <span className="flex flex-col">
            <span className="font-heading font-semibold text-foreground-950 group-hover:text-accent-600 transition-colors">
              {item.type}
            </span>
            <span className="text-xs text-foreground-500 mt-0.5">{item.desc}</span>
            <span className="text-xs text-accent-600 mt-1 font-medium">{item.count}</span>
          </span>
          <i className="ri-arrow-right-up-line absolute right-4 top-4 text-foreground-300 group-hover:text-accent-500 transition-colors"></i>
        </Link>
      ))}
    </div>
  );
}